import { useCallback, useContext, useState } from 'react';

import FiltersContext from '@/context/FiltersContext/FiltersContext';
import FilterBar from '@/storybook/components/FilterBar/FilterBar';
import useShareView from '@/hooks/useShareView';
import useSaveFilters from '@/hooks/useSaveFilters';
import SaveFiltersDialog from '@/components/filter/SaveFiltersDialog/SaveFiltersDialog';
import { AppliedFilterSetStorage } from '@/utils/filter/appliedFilterSetStorage';
import { useLocalFiltersRegistry } from '@/context/LocalFiltersRegistry/LocalFiltersRegistry';
import useActiveFilterBar from './useActiveFilterBar';
import AppliedFilterSetDialog from './AppliedFilterSetDialog';
import styles from './ActiveFiltersContainer.module.css';

const ActiveFiltersContainer = () => {
  const { handleShareView } = useShareView();
  const { handleSaveFilters, isLoading: isSaveLoading } = useSaveFilters();
  const { handleClearAllFilters } = useContext(FiltersContext);
  const { clearAllLocalFilters } = useLocalFiltersRegistry();
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);

  const { chips, detailsDialogFilter, isDetailsDialogOpen, closeDetailsDialog } = useActiveFilterBar();

  const handleOpenSaveDialog = useCallback(() => {
    setIsSaveDialogOpen(true);
  }, []);

  const handleCloseSaveDialog = useCallback(() => {
    setIsSaveDialogOpen(false);
  }, []);

  const handleSave = useCallback(
    async (filterName: string, isDefault: boolean) => {
      const success = await handleSaveFilters({ filterName, isDefault });
      if (success) {
        setIsSaveDialogOpen(false);
      }
    },
    [handleSaveFilters],
  );

  const handleClearAll = useCallback(() => {
    handleClearAllFilters();
    clearAllLocalFilters();
    AppliedFilterSetStorage.clear();
  }, [handleClearAllFilters, clearAllLocalFilters]);

  if (chips.length === 0) return null;

  return (
    <>
      <FilterBar
        className={styles.filterBar}
        filters={chips}
        onClearAllClick={handleClearAll}
        onSaveFiltersClick={handleOpenSaveDialog}
        onShareFiltersClick={handleShareView}
      />

      <SaveFiltersDialog
        isOpen={isSaveDialogOpen}
        isLoading={isSaveLoading}
        onSave={handleSave}
        onCancel={handleCloseSaveDialog}
      />

      <AppliedFilterSetDialog
        isOpen={isDetailsDialogOpen}
        appliedSet={detailsDialogFilter}
        onClose={closeDetailsDialog}
      />
    </>
  );
};

export default ActiveFiltersContainer;
